<template>
  <b-modal
    v-model="show"
    :title="modoEdicao ? 'Editar Job' : 'Novo Job'"
    size="lg"
    hide-footer
    no-close-on-backdrop
  >
    <b-form @submit.prevent="salvar">
      <b-row>
        <b-col md="8">
          <b-form-group label="Nome *">
            <b-form-input v-model="form.nome" maxlength="255" required />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Status">
            <b-form-select v-model="form.status">
              <b-form-select-option value="ATIVO">Ativo</b-form-select-option>
              <b-form-select-option value="PAUSADO">Pausado</b-form-select-option>
              <b-form-select-option value="INATIVO">Inativo</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="Descrição">
        <b-form-textarea v-model="form.descricao" rows="2" max-rows="4" />
      </b-form-group>

      <b-row>
        <b-col md="6">
          <b-form-group label="Integração *">
            <b-form-select v-model="form.integracaoid" required>
              <b-form-select-option :value="null">— Selecione —</b-form-select-option>
              <b-form-select-option v-for="i in integracoes" :key="i.integracaoid" :value="i.integracaoid">
                {{ i.nome }} ({{ i.metodo }})
              </b-form-select-option>
            </b-form-select>
            <small v-if="!integracoes.length" class="text-warning">
              Nenhuma integração cadastrada. Cadastre uma em <em>Integração ERP</em> antes de criar Jobs.
            </small>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Timeout (ms) — override opcional">
            <b-form-input v-model.number="form.timeout_ms" type="number" min="1000" placeholder="usa da integração" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            label="Status HTTP = sem novidade"
            description="Ex.: 204,304,400 — esses status viram SUCESSO com 0 registros.">
            <b-form-input v-model="form.vazio_se_status_http" placeholder="ex.: 204,400" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Frequência -->
      <div class="freq-block">
        <div class="d-flex justify-content-between align-items-center mb-50">
          <strong>Frequência de execução</strong>
          <b-form-checkbox v-model="avancado" switch size="sm">
            Modo avançado (cron)
          </b-form-checkbox>
        </div>

        <!-- Modo Simples -->
        <template v-if="!avancado">
          <b-row>
            <b-col md="4">
              <b-form-group label="Repetir">
                <b-form-select v-model="freq.tipo">
                  <b-form-select-option value="minutos">A cada X minutos</b-form-select-option>
                  <b-form-select-option value="horas">A cada X horas</b-form-select-option>
                  <b-form-select-option value="diario">Diariamente</b-form-select-option>
                  <b-form-select-option value="semanal">Semanalmente</b-form-select-option>
                  <b-form-select-option value="nunca">Não agendado (somente manual)</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="4" v-if="freq.tipo === 'minutos'">
              <b-form-group label="Intervalo (minutos)">
                <b-form-input v-model.number="freq.intervalo" type="number" min="1" max="59" />
              </b-form-group>
            </b-col>

            <b-col md="4" v-else-if="freq.tipo === 'horas'">
              <b-form-group label="Intervalo (horas)">
                <b-form-input v-model.number="freq.intervalo" type="number" min="1" max="23" />
              </b-form-group>
            </b-col>

            <template v-else-if="freq.tipo === 'diario'">
              <b-col md="4">
                <b-form-group label="Horário">
                  <b-form-input v-model="freq.hora" type="time" />
                </b-form-group>
              </b-col>
            </template>

            <template v-else-if="freq.tipo === 'semanal'">
              <b-col md="4">
                <b-form-group label="Dia da semana">
                  <b-form-select v-model.number="freq.diaSemana">
                    <b-form-select-option :value="1">Segunda-feira</b-form-select-option>
                    <b-form-select-option :value="2">Terça-feira</b-form-select-option>
                    <b-form-select-option :value="3">Quarta-feira</b-form-select-option>
                    <b-form-select-option :value="4">Quinta-feira</b-form-select-option>
                    <b-form-select-option :value="5">Sexta-feira</b-form-select-option>
                    <b-form-select-option :value="6">Sábado</b-form-select-option>
                    <b-form-select-option :value="0">Domingo</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Horário">
                  <b-form-input v-model="freq.hora" type="time" />
                </b-form-group>
              </b-col>
            </template>
          </b-row>
          <div class="freq-preview">
            <feather-icon icon="ClockIcon" size="14" class="mr-25" />
            <span>{{ resumoFrequencia }}</span>
            <code v-if="form.cron_expression" class="ml-1">{{ form.cron_expression }}</code>
          </div>
        </template>

        <!-- Modo Avançado -->
        <template v-else>
          <b-form-group label="Expressão Cron" description="5 campos: minuto hora dia-mes mes dia-semana. Ex.: '*/15 * * * *' (a cada 15 min), '0 9 * * 1-5' (9h em dias úteis).">
            <b-form-input v-model="form.cron_expression" placeholder="*/15 * * * *" />
          </b-form-group>
        </template>
      </div>

      <div class="d-flex align-items-center mt-1 mb-1">
        <b-form-checkbox v-model="form.ativo" switch>
          Job habilitado
        </b-form-checkbox>
      </div>

      <div class="d-flex justify-content-end" style="gap:6px">
        <b-button variant="outline-secondary" @click="show = false">Cancelar</b-button>
        <b-button type="submit" variant="primary" :disabled="salvando">
          <b-spinner small v-if="salvando" /> Salvar
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

const VAZIO = () => ({
  nome: '',
  descricao: '',
  integracaoid: null,
  cron_expression: '',
  ativo: true,
  status: 'ATIVO',
  timeout_ms: null,
  vazio_se_status_http: '',
});

const FREQ_VAZIA = () => ({
  tipo: 'minutos',
  intervalo: 15,
  hora: '08:00',
  diaSemana: 1,
});

const DIAS_SEMANA = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

export default {
  name: 'JobModal',
  props: {
    integracoes: { type: Array, default: () => [] },
  },
  data() {
    return {
      show: false,
      modoEdicao: false,
      salvando: false,
      jobId: null,
      form: VAZIO(),
      avancado: false,
      freq: FREQ_VAZIA(),
    };
  },
  computed: {
    resumoFrequencia() {
      const f = this.freq;
      if (f.tipo === 'nunca') return 'Sem agendamento — disparo apenas manual.';
      if (f.tipo === 'minutos') {
        const n = Number(f.intervalo) || 1;
        return n === 1 ? 'A cada minuto.' : `A cada ${n} minutos.`;
      }
      if (f.tipo === 'horas') {
        const n = Number(f.intervalo) || 1;
        return n === 1 ? 'A cada hora (no minuto 0).' : `A cada ${n} horas (no minuto 0).`;
      }
      if (f.tipo === 'diario') return `Todos os dias às ${f.hora}.`;
      if (f.tipo === 'semanal') return `Toda ${DIAS_SEMANA[f.diaSemana]} às ${f.hora}.`;
      return '';
    },
  },
  watch: {
    freq: {
      deep: true,
      handler() { if (!this.avancado) this.form.cron_expression = this._freqParaCron(); },
    },
    avancado(novo) {
      if (!novo) this.form.cron_expression = this._freqParaCron();
    },
  },
  methods: {
    ...mapActions('JobErp', ['criar', 'atualizar']),
    open(job) {
      this.modoEdicao = !!job;
      this.jobId = job ? job.jobid : null;
      if (job) {
        this.form = {
          nome: job.nome || '',
          descricao: job.descricao || '',
          integracaoid: job.integracaoid || null,
          cron_expression: job.cron_expression || '',
          ativo: job.ativo !== false,
          status: job.status || 'ATIVO',
          timeout_ms: job.timeout_ms || null,
          vazio_se_status_http: job.vazio_se_status_http || '',
        };
        const inferido = this._cronParaFreq(job.cron_expression);
        if (inferido) {
          this.freq = inferido;
          this.avancado = false;
        } else {
          this.freq = FREQ_VAZIA();
          // se já tinha cron mas não conseguimos inferir, abre em avançado
          this.avancado = !!job.cron_expression;
        }
      } else {
        this.form = VAZIO();
        this.freq = FREQ_VAZIA();
        this.avancado = false;
        // dispara cálculo inicial
        this.form.cron_expression = this._freqParaCron();
      }
      this.show = true;
    },
    /**
     * Converte os campos de frequência simples → expressão cron (5 campos).
     */
    _freqParaCron() {
      const f = this.freq;
      if (f.tipo === 'nunca') return '';
      if (f.tipo === 'minutos') {
        const n = Math.max(1, Math.min(59, Number(f.intervalo) || 1));
        return n === 1 ? '* * * * *' : `*/${n} * * * *`;
      }
      if (f.tipo === 'horas') {
        const n = Math.max(1, Math.min(23, Number(f.intervalo) || 1));
        return n === 1 ? '0 * * * *' : `0 */${n} * * *`;
      }
      const [hh, mm] = String(f.hora || '00:00').split(':').map((v) => Number(v) || 0);
      if (f.tipo === 'diario') return `${mm} ${hh} * * *`;
      if (f.tipo === 'semanal') return `${mm} ${hh} * * ${Number(f.diaSemana) || 0}`;
      return '';
    },
    /**
     * Tenta inferir os campos de frequência a partir de uma cron-expression.
     * Retorna null se a expressão não casar com nenhum padrão "simples".
     */
    _cronParaFreq(expr) {
      if (!expr) return null;
      const parts = String(expr).trim().split(/\s+/);
      if (parts.length !== 5) return null;
      const [min, hor, dom, mes, dow] = parts;
      if (dom !== '*' || mes !== '*') return null;

      // A cada N minutos: '*/N * * * *' ou '* * * * *'
      if (hor === '*' && dow === '*') {
        if (min === '*') return { tipo: 'minutos', intervalo: 1, hora: '08:00', diaSemana: 1 };
        const m = /^\*\/(\d+)$/.exec(min);
        if (m) return { tipo: 'minutos', intervalo: Number(m[1]), hora: '08:00', diaSemana: 1 };
      }
      // A cada N horas: '0 */N * * *' ou '0 * * * *'
      if (min === '0' && dow === '*') {
        if (hor === '*') return { tipo: 'horas', intervalo: 1, hora: '08:00', diaSemana: 1 };
        const m = /^\*\/(\d+)$/.exec(hor);
        if (m) return { tipo: 'horas', intervalo: Number(m[1]), hora: '08:00', diaSemana: 1 };
      }
      // Diário fixo: 'mm hh * * *'
      if (/^\d+$/.test(min) && /^\d+$/.test(hor) && dow === '*') {
        return {
          tipo: 'diario',
          intervalo: 15,
          hora: `${String(hor).padStart(2, '0')}:${String(min).padStart(2, '0')}`,
          diaSemana: 1,
        };
      }
      // Semanal fixo: 'mm hh * * d'
      if (/^\d+$/.test(min) && /^\d+$/.test(hor) && /^\d+$/.test(dow)) {
        return {
          tipo: 'semanal',
          intervalo: 15,
          hora: `${String(hor).padStart(2, '0')}:${String(min).padStart(2, '0')}`,
          diaSemana: Number(dow),
        };
      }
      return null;
    },
    async salvar() {
      if (!this.form.nome.trim()) {
        this.$bvToast.toast('Informe o nome do job.', { title: 'Atenção', variant: 'warning', solid: true });
        return;
      }
      if (!this.form.integracaoid) {
        this.$bvToast.toast('Selecione uma integração.', { title: 'Atenção', variant: 'warning', solid: true });
        return;
      }
      this.salvando = true;
      try {
        const payload = { ...this.form };
        if (payload.timeout_ms === '' || payload.timeout_ms === undefined) payload.timeout_ms = null;
        if (this.modoEdicao) {
          await this.atualizar({ id: this.jobId, payload });
          this.$bvToast.toast('Job atualizado.', { title: 'OK', variant: 'success', solid: true });
        } else {
          await this.criar(payload);
          this.$bvToast.toast('Job criado.', { title: 'OK', variant: 'success', solid: true });
        }
        this.show = false;
        this.$emit('saved');
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.error) || e.message || String(e);
        this.$bvToast.toast(`Falha ao salvar: ${msg}`, { title: 'Erro', variant: 'danger', solid: true });
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.freq-block {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px 14px;
  background: #fafafa;
  margin-bottom: 8px;
}
.freq-preview {
  font-size: 0.85rem;
  color: #555;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.freq-preview code {
  background: #e9ecef;
  color: #6f42c1;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.8rem;
}

// Dark mode — segue o padrão do tema Vuexy
.dark-layout {
  .freq-block {
    background: #161d31;            // mesmo tom do --theme-dark-card-bg
    border-color: #3b4253;
  }
  .freq-preview {
    color: #b4b7bd;
  }
  .freq-preview code {
    background: #283046;
    color: #d8b4fe;
  }
}
</style>
